<template>
  <div class="bg-svg absolute -z-50 h-screen w-screen"></div>
  <RouterView />
</template>

<script setup lang="ts"></script>
